import { TemplatesApi } from 'woofwoof-api';
import client, { axiosBaseUrl } from './client';

export const templateApi = new TemplatesApi(
  {
    basePath: axiosBaseUrl,
    isJsonMime: () => false,
  },
  undefined,
  //@ts-ignore
  client,
);
